import { render, staticRenderFns } from "./powerupItem.vue?vue&type=template&id=590e5e29&scoped=true"
import script from "./powerupItem.vue?vue&type=script&lang=js"
export * from "./powerupItem.vue?vue&type=script&lang=js"
import style0 from "./powerupItem.vue?vue&type=style&index=0&id=590e5e29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e5e29",
  null
  
)

export default component.exports